import { useRouteLoaderData } from "@remix-run/react";
import type { loader as rootLoader } from "../../root";

export const useIsLogin = () => {
  const root = useRouteLoaderData<typeof rootLoader>("root");
  return {
    isLogin: !!(root?.user),
  }
}

export const useAuthUser = () => {
  const root = useRouteLoaderData<typeof rootLoader>("root");
  return {
    user: root?.user,
  }
}